module.exports = __webpack_public_path__ + "static/media/g-icon-edit.951edf54.svg";